import { apiEndpoints } from "@/services/api/api";

export const changePasswordAction = async ({
  request,
}: {
  request: Request;
}) => {
  const changePasswordRequest = await request.json();

  try {
    await apiEndpoints.changePassword(changePasswordRequest);
    return true;
  } catch (err) {
    return err;
  }
};
